import React from "react";
import Position from "../../types/Position";
import { Modal } from "react-bootstrap";
import Resources from "../../types/Resources";
import { MapContainer, WMSTileLayer } from "react-leaflet";
import BaseWorkPermitInfo from "../../types/BaseWorkPermitInfo";
import PositionMarker from "./PositionMarker";

type PositionDisplayModalProps = {
    permit: BaseWorkPermitInfo |  undefined;
    show: boolean;
    onHide: () => void;
    resources: Resources;
};

function PositionDisplayModal({ permit, show, onHide, resources }: PositionDisplayModalProps) {
    const markers = permit ? permit.positions.map((p) => (
        <PositionMarker permitInfo={permit} position={p} resources={resources} key={p.id} />
    )) : [];

    return (
        <Modal show={show} onHide={onHide} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>{resources.get("Positions")}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="rounded-bottom p-0 overflow-hidden">
                <div className="container-fluid p-0">
                    <div className="col-12">
                        <MapContainer
                            center={[57.688111, 11.848859]}
                            zoom={14}
                            style={{ height: "80vh" }}
                            attributionControl={false}
                        >
                            {markers}
                            <WMSTileLayer
                                url="https://opengeodata.goteborg.se/services/ortofoto/wms/v1"
                                layers="orto_2023"
                                attribution={""}
                                maxNativeZoom={19}
                                maxZoom={19}
                                minZoom={13}
                            ></WMSTileLayer>
                        </MapContainer>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default PositionDisplayModal;
